import { render, staticRenderFns } from "./LeaveCommentAdded.vue?vue&type=template&id=1750f8b8"
import script from "./LeaveCommentAdded.vue?vue&type=script&lang=js"
export * from "./LeaveCommentAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports